import { IDLESTATUS_AWAY, IDLESTATUS_INACTIVE, IDLESTATUS_EXPIRED } from './constants'

import * as authActions from '../../redux/modules/auth';

import { routeActions } from 'react-router-redux';

export const activeStatusAction = (dispatch, getState) => console.log('welcome back!')

export const idleStatusDelay = idleStatus => (dispatch, getState) => {

  var state = getState()
  var user = state.auth.user;

  var expirationTime = 1800000;
  var awayTime = 20000;
  var inactiveTime = 60000;

  /*
  if( user.role == 'demo' ) {
    expirationTime = 300000;
    awayTime = 20000;
    inactiveTime = 30000;
  }*/



  if (idleStatus === IDLESTATUS_AWAY) {
    return awayTime // User becomes away after 20 seconds inactivity
  }

  if (idleStatus === IDLESTATUS_INACTIVE) {
    return inactiveTime
  }
  //return getInactiveDelayFromDB() // Call database to look up the users delay time
  if (idleStatus === IDLESTATUS_EXPIRED) {
    return expirationTime
  }


}


export const idleStatusAction = idleStatus => (dispatch, getState) => {

  if (idleStatus === IDLESTATUS_AWAY) {
    console.info('user is away...')
  }
  

  if (idleStatus === IDLESTATUS_INACTIVE) {
    console.info('user is away...')
  }

  if (idleStatus === IDLESTATUS_EXPIRED) {
    dispatch(authActions.logout()).then(() => dispatch(routeActions.push('/')))
  }

}